/**
 * Sort card sections by persisted `order` (used in editor, live preview, public card).
 */
export function sortCardSections(sections) {
  return [...(sections || [])].sort(
    (a, b) => (Number(a.order) || 0) - (Number(b.order) || 0)
  );
}
